var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-item"},[_c('div',{staticClass:"form-item-label"},[_vm._v(" "+_vm._s(_vm.label)),(_vm.required)?_c('i',{staticClass:"required"},[_vm._v("*")]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }